<span class="flex" [ngStyle]="{ &quot;transform&quot;: &quot;scale(&quot;+scaleValue+&quot;)&quot; }">
  <svg class="circle-loader" #svg width="40" height="40" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="15"></circle>
  </svg></span>
